import {ArgValidator, lodash, Logger, StringUtils} from 'neo-common';
import {IRealityCheck} from './IRealityCheck';

export class RealityCheckFactory {
    private static list: any = {};
    private static count = 0;

    public static register(component: any, componentType: string): void {
        const cmpName = component.name;
        if (cmpName === undefined || cmpName === '') {
            throw new Error('[RealityCheckFactory] specified component does not contain property "name"');
        }

        if (componentType === undefined || componentType === '') {
            throw new Error('[RealityCheckFactory] component type was not specified!');
        }

        const list = RealityCheckFactory.list;
        const reg = list[componentType];

        if (!reg) {
            list[componentType] = {
                component: component,
                type: componentType
            };

            this.count++;

            if (DEBUG) {
                Logger.debugGroup('Register reality check', `Reality check '${cmpName}' (type: ${componentType})`
                                                          + ` was successfully registered (${this.count} so far).`);
            }
        } else {
            throw new Error(`[RealityCheckFactory] Reality check "${cmpName}" (type: ${componentType})`
                            + ` is already registered!`);
        }
    }

    /**
     * Creates new instance of IRealityCheck implementation specified by 'type' parameter
     * @param type
     * @returns {null} if Reality Check implmentation specified by 'type' is not found; otherwise returns new instance.
     */
    public static create(type: string): IRealityCheck {
        ArgValidator.ensureStringIsNotNullOrEmpty(type, 'type');

        const list = RealityCheckFactory.list;
        const reg = lodash.find(list, (item: any) => StringUtils.equals(item.type, type, true));

        if (reg) {
            const classType: any = reg.component;
            return new classType() as IRealityCheck;
        }

        if (DEBUG) {
            Logger.debugGroup('[RealityCheckFactory]', `Create('${type}') could not found reality check with such type!`);
        }

        return null;
    }
}

/**
 * @decorator registerRealityCheck - registers reality check implementation
 */
export function registerRealityCheck(componentType: string) {
    return function (component: any) {
        RealityCheckFactory.register(component, componentType);
        component.prototype.__componentName__ = component.name;
        component.prototype.__componentType__ = componentType;
    };
}

const isBrowser = typeof window !== 'undefined';
if (isBrowser) {
    (window as any)['registerRealityCheck'] = registerRealityCheck;
}


/** WEBPACK FOOTER **
 ** ./Engine/RealityCheck/RealityCheckFactory.ts
 **/